import UpperCaseGreyText from '../UpperCaseGreyText/UpperCaseGreyText';
import { useEffect, useState, useRef } from 'react';
import Tooltip from '@mui/material/Tooltip';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';

function NRSuperIndexAndValue({ superIndex, value, extraSx, valueColor, customTooltipText, avatar }) {
  const theme = useTheme();
  const [isOverflowing, setIsOverflowing] = useState(false);
  const valueRef = useRef(null);

  useEffect(() => {
    if (valueRef.current) {
      setIsOverflowing(valueRef.current.scrollWidth > valueRef.current.clientWidth);
    }
  }, [value]);

  // React elements would stringify to "[object Object]" in the label.
  const isTextValue = typeof value === 'string' || typeof value === 'number';

  return (
    <Box tabIndex={0} aria-label={isTextValue ? `${superIndex}: ${value}` : superIndex} sx={{ display: 'flex', flexDirection: 'column', ...extraSx }}>
      <UpperCaseGreyText text={superIndex} />
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {avatar}
        <Tooltip title={customTooltipText || (isOverflowing ? value : '')}>
          <Box
            ref={valueRef}
            sx={{
              ...theme.typography.body2,
              wordBreak: 'break-all',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              color: valueColor || theme.palette.text.secondary
            }}
          >
            {value}
          </Box>
        </Tooltip>
      </Box>
    </Box>
  );
}
export default NRSuperIndexAndValue;
